<form [formGroup]="resetPasswordForm" class="reset-password__form" data-testid="reset-password-form">
  <mat-form-field appearance="outline" class="reset-password__field">
    <mat-label>New Password</mat-label>
    <input
      matInput
      [type]="showPassword() ? 'text' : 'password'"
      formControlName="newPassword"
      placeholder="Enter new password"
      autocomplete="new-password"
      data-testid="new-password-input"
    />
    <button
      mat-icon-button
      matSuffix
      type="button"
      tabindex="-1"
      (click)="togglePasswordVisibility()"
      [attr.aria-label]="'Toggle password visibility'"
      data-testid="new-password-toggle"
    >
      <mat-icon>{{ showPassword() ? "visibility_off" : "visibility" }}</mat-icon>
    </button>
    @if (newPasswordControl.errors) {
    <mat-error data-testid="new-password-required-error">
      {{ getPasswordErrorMessage("newPassword") }}
    </mat-error>
    }
  </mat-form-field>

  <!-- Confirm Password Field -->
  <mat-form-field appearance="outline" class="reset-password__field">
    <mat-label>Confirm New Password</mat-label>
    <input
      matInput
      [type]="showConfirmPassword() ? 'text' : 'password'"
      formControlName="confirmPassword"
      placeholder="Confirm new password"
      autocomplete="new-password"
      data-testid="confirm-password-input"
    />
    <button
      mat-icon-button
      matSuffix
      type="button"
      tabindex="-1"
      (click)="toggleConfirmPasswordVisibility()"
      [attr.aria-label]="'Toggle confirm password visibility'"
      data-testid="confirm-password-toggle"
    >
      <mat-icon>{{ showConfirmPassword() ? "visibility_off" : "visibility" }}</mat-icon>
    </button>
    @if (confirmPasswordControl.hasError('required')) {
    <mat-error data-testid="confirm-password-required-error"> Please confirm your password </mat-error>
    } @if (confirmPasswordControl.hasError('passwordMismatch')) {
    <mat-error data-testid="confirm-password-mismatch-error"> Passwords do not match </mat-error>
    }
  </mat-form-field>

  @if (newPasswordControl.value && confirmPasswordControl.value) {
  <div class="reset-password__password-match">
    <mat-icon [class]="passwordsMatch() ? 'reset-password__match-icon--success' : 'reset-password__match-icon--error'">
      {{ passwordsMatch() ? "check_circle" : "error" }}
    </mat-icon>
    <span [class]="passwordsMatch() ? 'reset-password__match-text--success' : 'reset-password__match-text--error'">
      {{ passwordsMatch() ? "Passwords match" : "Passwords do not match" }}
    </span>
  </div>
  }

  <div class="reset-password__actions">
    <wil-cta-button
      [loading]="isSubmitting()"
      [disabled]="!canSubmit()"
      [ctaText]="'Reset Password'"
      (ctaClick)="onSubmit()"
      [style]="'primary'"
      [size]="'large'"
      data-testid="reset-password-submit-button"
    ></wil-cta-button>

    @if (token()) {
    <button type="button" mat-button class="reset-password__back-button" (click)="goHome.emit()" data-testid="back-to-home-button">
      Back to Home
    </button>
    }
  </div>
</form>
